import React from 'react'
import './HomeServices.css'
import Data from '../../data/Data'
import {Eco, Public, SupervisorAccount} from '@material-ui/icons';

const HomeServices = () => {
    return (
        <div className='home-services' id="services">
            <h1 className='home-services-heading'>MEET OUR SERVICES</h1>
            <div className='home-services-container'>
                <div className="home-services-container-card">
                    <div className='home-services-container-cardInfo'>
                        <div className='icon'>
                        <SupervisorAccount fontSize='inherit'/>
                        </div>
                        <h3>{Data.serviceCard1Header}</h3>
                        <ul className='home-services-container-features'>
                            <li style={{textAlign:'center'}}>{Data.serviceCard1Description}</li>
                        </ul>
                    </div>
                </div>
                <div className="home-services-container-card">
                    <div className='home-services-container-cardInfo'>
                        <div className='icon'>
                        <Eco fontSize='inherit'/>
                        </div>
                        <h3>{Data.serviceCard2Header}</h3>
                        <ul className='home-services-container-features'>
                        <li style={{textAlign:'center'}}>{Data.serviceCard2Description}</li>
                        </ul>
                    </div>
                </div>
                <div className="home-services-container-card">
                    <div className='home-services-container-cardInfo'>
                        <div className='icon'>
                        <Public fontSize='inherit'/>
                        </div>
                        <h3>{Data.serviceCard3Header}</h3>
                        <ul className='home-services-container-features'>
                        <li style={{textAlign:'center'}}>{Data.serviceCard3Description}</li>
                        </ul>
                    </div>
                </div>
                
            </div>

        </div>
    )
}

export default HomeServices
